import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const NavigationBreadcrumb = ({ language = 'en' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const routeLabels = {
    '/dashboard': {
      en: 'Dashboard',
      fr: 'Tableau de bord',
      ar: 'لوحة القيادة'
    },
    '/client-management': {
      en: 'Client Management',
      fr: 'Gestion des clients',
      ar: 'إدارة العملاء'
    },
    '/case-management': {
      en: 'Case Management',
      fr: 'Gestion des dossiers',
      ar: 'إدارة القضايا'
    },
    '/calendar-scheduling': {
      en: 'Calendar & Scheduling',
      fr: 'Calendrier et planification',
      ar: 'التقويم والجدولة'
    },
    '/document-management': {
      en: 'Document Management',
      fr: 'Gestion des documents',
      ar: 'إدارة المستندات'
    },
    '/billing-invoice': {
      en: 'Billing & Invoices',
      fr: 'Facturation',
      ar: 'الفواتير'
    },
    '/user-administration': {
      en: 'User Administration',
      fr: 'Administration des utilisateurs',
      ar: 'إدارة المستخدمين'
    }
  };

  const homeLabel = {
    en: 'Home',
    fr: 'Accueil',
    ar: 'الرئيسية'
  };

  const buildBreadcrumbs = () => {
    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [
      {
        label: homeLabel?.[language],
        path: '/dashboard',
        isHome: true
      }
    ];

    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const routeLabel = routeLabels?.[currentPath];
      if (routeLabel) {
        breadcrumbs?.push({
          label: routeLabel?.[language],
          path: currentPath,
          isHome: false
        });
      }
    });

    return breadcrumbs;
  };

  const breadcrumbs = buildBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      {breadcrumbs?.map((crumb, index) => (
        <div key={crumb?.path} className="breadcrumb-item">
          {index > 0 && (
            <span className="breadcrumb-separator">
              <Icon name="ChevronRight" size={16} />
            </span>
          )}
          {index === breadcrumbs?.length - 1 ? (
            <span className="breadcrumb-current">{crumb?.label}</span>
          ) : (
            <button
              className="breadcrumb-link"
              onClick={() => navigate(crumb?.path)}
            >
              {crumb?.isHome && <Icon name="Home" size={16} className="mr-1" />}
              {crumb?.label}
            </button>
          )}
        </div>
      ))}
    </nav>
  );
};

export default NavigationBreadcrumb;